import * as React from 'react'
import { useMemo } from 'react'
import { LoaderCircleIcon } from 'lucide-react'

import { cn } from '@/lib/utils'
import { Button, buttonVariants } from '@/components/ui/button'

type ButtonProps = React.ComponentProps<typeof Button>

export type SubmitButtonProps = ButtonProps & {
  isSubmitting?: boolean
  isValid?: boolean
  isDirty?: boolean
}

export const SubmitButton = React.forwardRef<
  HTMLButtonElement,
  SubmitButtonProps
>(({ className, variant, size, ...props }, ref) => {
  const { isSubmitting, isValid, isDirty, ...buttonProps } = props
  const disabled = useMemo(() => {
    if (isSubmitting) return true

    if (typeof isDirty === 'boolean') return !isDirty
    if (typeof isValid === 'boolean') return !isValid

    return props.disabled
  }, [props.disabled, isSubmitting, isValid, isDirty])

  return (
    <Button
      type="submit"
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...buttonProps}
      disabled={disabled}
    >
      {props.children}
      {props.isSubmitting && (
        <LoaderCircleIcon className="ml-2 size-4 animate-spin" />
      )}
    </Button>
  )
})

SubmitButton.displayName = 'SubmitButton'
